module.exports = __webpack_public_path__ + "img/img93.e3048f6f.svg";